
import { authHeader } from '../helpers/authHeader';
import apiClient from '../helpers/apiClient';

export const broadCastService = {
  submitBroadCast,
  getCustomerList,
  getBroadcastStatus,
};

async function submitBroadCast(url, form) {
  const response = await apiClient.post(url, form, {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  });
  return response.data;
}

async function getCustomerList(url) {
  const response = await apiClient.get(url + '/customer-list', {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  });
  return response.data;
}

async function getBroadcastStatus(url) {
  const response = await apiClient.get(url + '/message-status', {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  });
  return response.data;
}
